export default "__VITE_ASSET__CPlA1cE5__"